<section class="banner-carousel">
  <div id="bannerCarousel" class="bannerCarousel"   [ngClass]="{'dealer-margin-mobile': hasDealerCode}">
    <ng-container *ngIf="processedBannerList?.length == 0 || !isLoading; else loadingContent">
      <div  *ngFor="let item of skeletonService.generateFake(1);let i = index;">
        <ngx-skeleton height="570px"></ngx-skeleton>
      </div>
    </ng-container>
    <div *ngIf="processedBannerList?.length > 0">
      <img [src]='environment1 + "assets/images/Square-T-blue.png"' class="t-image" alt="T">
      <div class="horizontal-line"></div>
      <div class="vertical-line"></div>
      <div class="bottom-horizontal-line"></div>
      <div class="bottom-vertical-line"></div>
    </div>
    <ng-template #loadingContent>
      <owl-carousel-o [options]="customOptionsForBanner">
        <ng-container *ngFor="let data of processedBannerList">
          <ng-template carouselSlide [id]="data?.id">
            <a (click)="data?.banner_link ? GetTest(data) : $event.preventDefault()"
               [ngStyle]="{'cursor': data?.banner_link ? 'pointer' : 'not-allowed'}">
              <div class="top-banner-wrapper">
                <img [src]="data?.updatedUrl" width="100%" height="504px"
                     [alt]="data?.title" class="active" style="object-fit: fill;" loading="eager">
              </div>
            </a>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-template>

  </div>
  <div class="search-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-sm-10 col-md-9 col-lg-9 col-xl-9 search-wrapper">
          <div class="row application" >
            <div class="col p-0 b-r-1 or-option">
              <div class="search-form-wrapper position-relative">
                <label class="search-form-label">Application</label>

                <input type="text" class="search-form-control product-search bannerApplication" [value]="selectedApplication"
                placeholder="Ex: Cement, Agriculture, FMCG, etc" (click)="openModal()" id="applicationFilter" #applicationFilter (keyup)="searchFilter('application',applicationFilter.value)"/>
                <div class="search-modal-auto" id="modalAuto" *ngIf="applicationData && applicationData?.length > 0">
                  <ul class="product-auto-list bannerApplication">
                    <li *ngFor="let item of applicationData" (click)="onChangeApplication(item,'Application'); closeModal();">
                      <a href="javascript:void(0)">{{item}}</a>
                    </li>
                  </ul>

                </div>
                <div class="search-modal-auto" id="modalAuto" *ngIf="applicationData?.length == 0">
                  <ul class="product-auto-list bannerApplication">
                    <li>
                      <a href="javascript:void(0)">No data found.</a>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
            <div class="col p-0 b-r-1 or-option">
              <div class="search-form-wrapper position-relative">
                <label class="search-form-label">Segment</label>

                <input type="text" class="search-form-control product-search"  [value]="selectedSegment"
                  placeholder="Ex: LCV, Buses, Pickups, etc" (click)="openModalSegment()" id="segmentFilter" #segmentFilter (keyup)="searchFilter('segment',segmentFilter.value)"/>
                <div class="search-sagment-auto" *ngIf="segmentsData && segmentsData?.length > 0" id="modalAutoSegment">
                  <div class="row g-3">
                    <div class="col-4 col-md-3"   *ngFor="let item of segmentsData" (click)="onChangeApplication(item.eleName,'Segment'); closeModalSegment();">
                      <a href="javascript:void(0)">
                        <div class="img-wrapper">
                          <img alt="banner" [src]="item.img_url" loading="lazy"/>
                        </div>
                        <div class="text-wrapper" [class.selected]="selectedSegment === item.eleName">
                          {{item.eleName}}
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="search-modal-auto" id="modalAuto" *ngIf="segmentsData?.length == 0">
                  <ul class="product-auto-list bannerApplication">
                    <li>
                      <a href="javascript:void(0)">No data found.</a>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
            <div class="col p-0 b-r-1">
              <div class="search-form-wrapper position-relative">
                <label class="search-form-label">Product/Model</label>

                <input type="text" class="search-form-control product-search"
                  placeholder="Ex: Intra V50, 407, Ace gold, etc." (click)="openModalProduct()" [value]="selectedProduct"  id="productFilter" #productFilter (keyup)="searchFilter('product',productFilter.value)"/>

                <div class="search-modal-auto" id="modalAutoProduct" *ngIf="productModelData && productModelData?.length > 0">
                  <div class="trending-vehicle">Trending Vehicles</div>
                  <ul class="product-auto-list">
                    <li *ngFor="let item of productModelData" (click)="onSelectProduct(item)">
                      <a href="javascript:void(0)"> <img alt="#" [src]='environment1 + "assets/images/chart-arrow.svg"' />
                        {{ item }}</a>
                    </li>
                  </ul>
                </div>
                <div class="search-modal-auto" id="modalAuto" *ngIf="productModelData?.length == 0">
                  <ul class="product-auto-list bannerApplication">
                    <li>
                     No data found.
                    </li>
                  </ul>

                </div>
              </div>
            </div>
            <div class="col-auto ps-0">
              <button data-toggle="tooltip" data-placement="top" title="Click here for Search Vehicle" [disabled]= "!selectedApplication &&!selectedSegment && !selectedProduct" class="btn btn-search" (click)="search()" [routerLink]="['product-list']" style="width:110%;" [queryParams]="{ vehicle_application: selectedApplication}">
                <img [src]="environment1 + 'images/new-images/search.svg'" alt="search" loading="lazy">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
